
import { 
  Dropdown, 
  DropdownTrigger, 
  DropdownMenu, 
  DropdownItem, 
  Avatar,
  User,
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from '@heroui/react';
import { useDisclosure } from '@heroui/react';
import { useAuthStore } from '../../stores/auth.store';
import UserConfigModal from './UserConfigModal';

const UserMenu = () => {
  const { user, isLoggedIn, logout } = useAuthStore();
  const { isOpen: isConfigOpen, onOpen: onConfigOpen, onOpenChange: onConfigOpenChange } = useDisclosure();
  const { isOpen: isLogoutConfirmOpen, onOpen: onLogoutConfirmOpen, onOpenChange: onLogoutConfirmOpenChange } = useDisclosure();

  if (!isLoggedIn || !user) {
    return null;
  }

  const handleLogout = async () => {
    await logout();
    onLogoutConfirmOpenChange();
  };

  return (
    <>
      <Dropdown placement="bottom-end">
        <DropdownTrigger>
          <Avatar
            isBordered
            as="button"
            className="transition-transform"
            color="secondary"
            name={user.username || 'Usuario'}
            size="sm"
            src={user.email ? `https://gravatar.com/avatar/${user.email}?d=identicon` : undefined}
          />
        </DropdownTrigger>
        <DropdownMenu aria-label="User menu actions">
          <DropdownItem key="profile" className="h-14 gap-2">
            <User
              name={user.username}
              description={user.email}
              classNames={{
                name: "text-default-600",
                description: "text-default-400",
              }}
            />
          </DropdownItem>
          <DropdownItem key="config" onClick={onConfigOpen}>
            Configuración
          </DropdownItem>
          <DropdownItem key="role" isReadOnly className="text-sm text-gray-500">
            Rol: {user.role?.name || 'N/A'}
          </DropdownItem>
          <DropdownItem key="logout" color="danger" onClick={onLogoutConfirmOpen}>
            Cerrar Sesión
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <UserConfigModal isOpen={isConfigOpen} onOpenChange={onConfigOpenChange} />
      
      {/* Logout Confirmation Modal */}
      <Modal 
        backdrop="opaque" 
        isOpen={isLogoutConfirmOpen} 
        onOpenChange={onLogoutConfirmOpenChange}
        isDismissable={false}
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1 text-orange-500">
                Confirmar Cierre de Sesión
              </ModalHeader>
              <ModalBody>
                <p>
                  ¿Estás seguro de que deseas cerrar sesión? Se perderá cualquier dato no guardado.
                </p>
              </ModalBody>
              <ModalFooter>
                <Button color="default" variant="flat" onClick={onClose}>
                  Cancelar
                </Button>
                <Button color="warning" onClick={handleLogout}>
                  Cerrar Sesión
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

export default UserMenu;